import { Component } from '@angular/core';
import { BasicCardComponent } from './basic-card.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'mwe-basic-card-bodyless',
  templateUrl: './basic-card-bodyless.component.html',
  imports: [NgClass],
})
export class BasicCardBodylessComponent extends BasicCardComponent {}
